import { Avatar, type AvatarProps } from '@dev-spendesk/grapes';

export const UserAvatar = ({
  id,
  name,
  avatar,
  className,
  ...props
}: Omit<AvatarProps, 'src' | 'text' | 'variant' | 'iconName'> & {
  id: string;
  name: string;
  avatar?: string;
}) => {
  const avatarSource = getCachedUserAvatar({ id, src: avatar });

  return (
    <Avatar
      {...props}
      src={avatarSource}
      text={name}
      variant="circle"
      className={`shrink-0 ${className ?? ''}`}
      lazyLoad
    />
  );
};

/**
 * Cache
 *
 * In some part of the application we do not have the user avatar URL (e.g. in the events of timeline history),
 * so we cache the avatar URL whenever we have it to have a chance to display it where it is missing.
 */

const cache = new Map<string, string>();

const getCachedUserAvatar = ({
  id,
  src,
}: {
  id: string;
  src: string | undefined;
}) => {
  let avatarSource = src;
  const hasCachedAvatar = cache.has(id);

  if (!avatarSource && id && hasCachedAvatar) {
    avatarSource = cache.get(id);
  }

  if (avatarSource && id && !hasCachedAvatar) {
    cache.set(id, avatarSource);
  }

  return avatarSource;
};
